import api from "../../services/api/index";
import { RT_EditorValue } from "./rich-text/types";

// ----------------------------------------------------------------------

export type NotificationData = {
  id: string;
  title: string;
  content: RT_EditorValue;
  date: Date;
  read: boolean;
};

// ----------------------------------------------------------------------

export const services = {
  listNotifications: async (cpf: string): Promise<NotificationData[]> => {
    api.defaults.headers.common = {
      Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
    };

    const response = await api.get<{
      notificacoes: {
        id: string;
        titulo: string;
        corpo: string;
        lida: 0 | 1;
        dataHoraEnvio: string;
      }[];
    }>("/csp/representante/notificacoes", {
      params: { cpf },
    });

    if (!response.data) return [];

    return response.data.notificacoes
      .map((item) => ({
        id: item.id,
        title: item.titulo,
        content: JSON.parse(item.corpo) as RT_EditorValue,
        read: Boolean(item.lida),
        date: new Date(item.dataHoraEnvio),
      }))
      .sort((a, b) => b.date.getTime() - a.date.getTime());
  },

  setNotificationRead: async (id: string): Promise<void> => {
    api.defaults.headers.common = {
      Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
    };

    await api.put("/csp/notificacaorepresentante/ler", { idNotificacao: id });
  },
};
